import { Box, Button, Flex, Icons, Page, Section, Typography } from 'components';
import styled from 'styled-components';

const Icon = styled(Icons)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.primary_400};
`;

const SquareLines = styled('i')`
  position: relative;
  position: absolute;
  left: 0;
  width: 0px;
  height: 0px;

  &::after {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.colors.primary_200};
    position: absolute;
    z-index: 1000;
  }

  &::before {
    content: '';
    display: block;

    border-top: 2px solid ${({ theme }) => theme.colors.white25};
    border-right: 2px solid ${({ theme }) => theme.colors.white25};
    position: absolute;

    right: 0px;
    z-index: 1;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
    ${mediaQueries.mobile} {
      top: 1px;
      left: -25px;

      &::after {
        width: 14px;
        height: 14px;
      }

      &::before {
        top: -30px;
        width: 150px;
        height: 230px;
      }
    }

    ${mediaQueries.tablet} {
      left: -30px;

      &::after {
        width: 14px;
        height: 14px;
        top: 3px;
        left: 0px;
      }

      &::before {
        top: -40px;
        width: 100px;
        height: 150px;
      }
    }

    ${mediaQueries.desktop} {
      top: 4px;
      left: -40px;

      &::after {
        width: 17px;
        height: 17px;
        top: 0px;
        left: 0px;
      }

      &::before {
        top: -40px;
        width: 150px;
        height: 280px;
      }
    }
  `;
  }}
`;

interface CertificateProps {
  title: string;
  class: string;
}
const CertificatesView = () => {
  const certificates: CertificateProps[] = [
    { title: 'Concluido em 12/05/2023', class: 'Formação ANCORD' },
    { title: 'Concluido em 12/05/2023', class: 'Formação ANCORD' },
    { title: 'Concluido em 12/05/2023', class: 'Formação ANCORD' },
    { title: 'Concluido em 12/05/2023', class: 'Formação ANCORD' },
    { title: 'Concluido em 12/05/2023', class: 'Formação ANCORD' },
  ];
  return (
    <Page title="Meus certificados">
      <Flex flexGrow={0} bg="navbarBg">
        <Section flexDirection={{ m: 'column', d: 'row' }} justifyContent="space-between">
          <Flex flexGrow={0} flexDirection="column" pt={{ m: 40, d: 40 }} pb={{ m: 60, d: 100 }}>
            <Box position="relative">
              <SquareLines />
              <Typography type="type5" color="white" fontWeight="bold" upper>
                Meus
              </Typography>
            </Box>

            <Typography type="type11" color="white" fontWeight="bold" mt={2}>
              Certificados
            </Typography>
          </Flex>

          <Flex width={{ d: 420 }} ml={{ d: 60 }} flexShrink={0} flexGrow={0} />
        </Section>
      </Flex>

      <Flex py={{ m: 30, t: 60, d: 90 }} bg="gray_200" flexGrow={0}>
        <Section flex={1} flexDirection={{ m: 'column', d: 'row' }} flexWrap="wrap">
          {certificates?.map((certificate, index) => {
            return (
              <Flex flexGrow={0} key={index} mb="4" mr={2}>
                <Button
                  type="button"
                  paddingY={16}
                  paddingX={16}
                  height="auto"
                  width={380}
                  bg="black"
                  color="primary_400"
                  colorHover="primary_400"
                  size="small"
                  borderRadius={4}
                  onClick={() => {}}
                >
                  <Flex flexDirection="column" alignItems="flex-start">
                    <Typography type="type0" color="primary_400">
                      {certificate.title}
                    </Typography>
                    <Flex mt={2} width="100%" alignItems="center" justifyContent="space-between">
                      <Typography type="type2" color="white">
                        {certificate.class}
                      </Typography>
                      <Icon icon="chevronRight" />
                    </Flex>
                  </Flex>
                </Button>
              </Flex>
            );
          })}
        </Section>
      </Flex>
    </Page>
  );
};

export default CertificatesView;
